import axios from "axios";
import { api, headers } from "../../app/conf";
import { makeQuery } from "../../shared/helpers/commons";
import company from "../sagas/company";

export const getCompanies = (filters, token) =>
    axios({
        method: "get",
        url: `${api}/companies?${makeQuery(filters)}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        }
    });

    export const getPlans = (token, filters = {}) =>
        axios({
          method: "get",
          url: `${api}/plans?${makeQuery(filters)}`,
          headers: {
            ...headers,
            "X-Access-Token": token
          }
        });


export const getPlanById = (token, planId) =>
    axios.get(`${api}/plans/${planId}`, {
        headers: { Authorization: `Bearer ${token}` }
    });

    export const getCompanyPlans = (companyId, token) =>
        axios({
          method: 'get',
          url: `${api}/companies/${companyId}/plans`,
          headers: {
            ...headers,
            'X-Access-Token': token,
          }
        });
      
      
export const postCompanies = (company, token) =>
    axios({
        method: "post",
        url: `${api}/companies`,
        headers: {
            ...headers,
            "X-Access-Token": token
        },
        data: company
    });

export const putCompanies = (company, token) =>
    axios({
        method: "put",
        url: `${api}/companies/${company._id}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        },
        data: company
    });

export const postTestEmailCompany = (testEmail, companyId, token) => 
    axios({
        method: "post",
        url: `${api}/companies/emails/tests/${companyId}/${testEmail}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        }
    })